import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { LoggerService } from '../../../shared/services/logger/logger.service';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import {
  ITrackingAction,
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { AddNoteBuilder } from './add-note.builder';

@Component({
  selector: 'app-add-note',
  templateUrl: './add-note.component.html',
  styleUrls: ['./add-note.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [AddNoteBuilder],
})
export class AddNoteComponent implements OnInit, OnDestroy {
  @Input() note: string;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @Output() onNoteChange: EventEmitter<string> = new EventEmitter<string>();

  formControl: FormControl;
  trackingAction: ITrackingAction;

  constructor(
    private _addNoteBuilder: AddNoteBuilder,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder,
    private _loggerService: LoggerService
  ) {}

  ngOnInit() {
    this.formControl = this._addNoteBuilder.buildFormControl(this.note);
    this.trackingAction = this._trackingActionBuilder.buildButtonTapped(
      'add_notes',
      this.trackingScreenName
    );
  }

  updateNote() {
    this._loggerService.log('save document note');

    this.onNoteChange.emit(this.formControl.value);
  }

  ngOnDestroy() {
    if (this.formControl && this.formControl.dirty) {
      this.updateNote();

      this.formControl.markAsPristine();
    }
  }
}
